<script lang="ts">
  import { TextField } from '@shared/ui/fields/text-field';
  import { snacks } from '@features/snackbar/store/snacks';
  import { superForm } from 'sveltekit-superforms/client';
  import { Icon } from '@shared/ui/icon';
  import type { institutionsSubscribeFormSchema } from '../model';
  import { page } from '$app/stores';

  const data = $page.data.form;

  const { form, errors, enhance, reset } = superForm<typeof institutionsSubscribeFormSchema>(data, {
    resetForm: true,
    taintedMessage: false,
    multipleSubmits: 'allow',
    id: 'subscribe',
    onError: ({ result }) => {
      const { status } = result;

      if (status === 500) {
        snacks.push({ type: 'error', message: 'Something went wrong' });
      }
    },
    onResult: ({ result }) => {
      if (result.type === 'success') {
        snacks.push({ type: 'success', message: 'You have been successfully subscribed!' });

        reset();
      }
    },
  });
</script>

<form
  class="w-full"
  method="POST"
  action="/api/institutions-subscribe?institutionId={$page.data.configurations.id}"
  use:enhance
>
  <TextField
    name="email"
    inputmode="email"
    state="{$errors.email && 'error'}"
    helperText="{$errors?.email && $errors.email[0]}"
    placeholder="Email"
    bind:value="{$form.email}"
    fieldClass="text-default-50 px-0 subscribe-input"
    containerClass="border-b border-t-0 border-x-0 border-dark-500 bg-transparent rounded-none"
  />

  <button
    class="bg-dark-400 group flex w-full items-center justify-center gap-5 rounded-lg py-2 text-xl font-medium md:py-3"
    type="submit"
  >
    <span class="text-base"> Subscribe </span>

    <Icon width="{24}" height="{24}" name="arrow" classes="transition-transform group-hover:translate-x-1" />
  </button>
</form>

<style lang="scss">
  :global(.subscribe-input:-webkit-autofill),
  :global(.subscribe-input:-webkit-autofill:hover) {
    -webkit-text-fill-color: rgb(255, 255, 255);
    -webkit-box-shadow: 0 0 0px 40rem rgb(27, 27, 27) inset;
  }

  :global(.subscribe-input:-webkit-autofill:focus) {
    -webkit-text-fill-color: rgb(255, 255, 255);
    -webkit-box-shadow: 0 0 0px 40rem rgb(27, 27, 27) inset;
  }
</style>
